import { AlignType, BorderType, PaddingType } from 'common/types/styleTypes'
import { WebsiteSettingsTypographyTypeEnum } from 'src/shared/types/website-settings-types'
import { useCalculateBorder } from '../use-calculate-border'
import { useCalculatePadding } from '../use-calculate-padding'
import { useCalculateFontFamily } from '../use-calculate-typography/use-calculate-font-family'
import { useCalculateFontSize } from '../use-calculate-typography/use-calculate-font-size'
import { useCalculateLetterSpacing } from '../use-calculate-typography/use-calculate-letter-spacing'
import { useCalculateLineHeight } from '../use-calculate-typography/use-calculate-line-height'
import { useCalculateTextAlign } from '../use-calculate-typography/use-calculate-text-align'
import {
  UseCalculateFieldsThemeColorsProps,
  useCalculateFieldsThemeColors,
} from './use-calculate-fields-theme-colors'

interface UseCalculateFormFieldStylesProps
  extends UseCalculateFieldsThemeColorsProps {
  border?: Partial<BorderType>
  mobileBorder?: Partial<BorderType>
  padding?: PaddingType
  mobilePadding?: Partial<PaddingType>
  fontSize?: number
  mobileFontSize?: number
  lineHeight?: number
  mobileLineHeight?: number
  textAlign?: AlignType
  mobileTextAlign?: AlignType
  letterSpacing?: number
  mobileLetterSpacing?: number
  fontFamily?: string
  mobileFontFamily?: string
}
export const useCalculateFormFieldStyles = ({
  border,
  mobileBorder,
  padding,
  mobilePadding,
  fontFamily,
  mobileFontFamily,
  fontSize,
  mobileFontSize,
  lineHeight,
  mobileLineHeight,
  textAlign,
  mobileTextAlign,
  letterSpacing,
  mobileLetterSpacing,
  color,
  mobileColor,
  backgroundColor,
  mobileBackgroundColor,
}: UseCalculateFormFieldStylesProps) => {
  const returnUseCalculatePadding = useCalculatePadding({
    padding,
    mobilePadding,
    type: WebsiteSettingsTypographyTypeEnum.FormField,
  })

  const returnUseCalculateBorder = useCalculateBorder({
    border,
    mobileBorder,
    type: WebsiteSettingsTypographyTypeEnum.FormField,
  })
  const returnUseCalculateFontFamily = useCalculateFontFamily({
    fontFamily,
    mobileFontFamily,
    typographyType: WebsiteSettingsTypographyTypeEnum.FormField,
  })

  const returnUseCalculateFontSize = useCalculateFontSize({
    fontSize,
    mobileFontSize,
    typographyType: WebsiteSettingsTypographyTypeEnum.FormField,
  })

  const returnUseCalculateLineHeight = useCalculateLineHeight({
    fontSize,
    mobileFontSize,
    lineHeight,
    mobileLineHeight,
    typographyType: WebsiteSettingsTypographyTypeEnum.FormField,
  })

  const returnUseCalculateTextAlign = useCalculateTextAlign({
    textAlign,
    mobileTextAlign,
    typographyType: WebsiteSettingsTypographyTypeEnum.FormField,
  })

  const returnUseCalculateLetterSpacing = useCalculateLetterSpacing({
    letterSpacing,
    mobileLetterSpacing,
    typographyType: WebsiteSettingsTypographyTypeEnum.FormField,
  })

  const returnUseCalculateFieldsThemeColors = useCalculateFieldsThemeColors({
    color,
    mobileColor,
    backgroundColor,
    mobileBackgroundColor,
  })

  return {
    ...returnUseCalculatePadding,
    ...returnUseCalculateBorder,
    ...returnUseCalculateFontSize,
    calculatedFontSize: {
      mobile: returnUseCalculateFontSize.calculatedFontSize.mobile as number,
      desktop: returnUseCalculateFontSize.calculatedFontSize.desktop as number,
    },
    ...returnUseCalculateLineHeight,
    ...returnUseCalculateTextAlign,
    ...returnUseCalculateLetterSpacing,
    ...returnUseCalculateFontFamily,
    ...returnUseCalculateFieldsThemeColors,
  }
}
